import { createSelector } from "reselect";

import { getSearchedLeg } from "@app/helpers/udm";

import { getSearch, getTrips } from "../state-accessors";

export const getSearchedLegByTripId = createSelector(
  [getSearch, getTrips, (_: unknown, trip_id: string) => trip_id],
  (search, trips, trip_id) => {
    return trips[trip_id] ? getSearchedLeg(search, trips[trip_id]) : undefined;
  }
);
